import _regeneratorRuntime from "/tmp/fleetadvise-production/28/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";

var _marked =
/*#__PURE__*/
_regeneratorRuntime.mark(flatten);

function flatten(arrays) {
  var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, array;

  return _regeneratorRuntime.wrap(function flatten$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _iteratorNormalCompletion = true;
          _didIteratorError = false;
          _iteratorError = undefined;
          _context.prev = 3;
          _iterator = arrays[Symbol.iterator]();

        case 5:
          if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
            _context.next = 11;
            break;
          }

          array = _step.value;
          return _context.delegateYield(array, "t0", 8);

        case 8:
          _iteratorNormalCompletion = true;
          _context.next = 5;
          break;

        case 11:
          _context.next = 17;
          break;

        case 13:
          _context.prev = 13;
          _context.t1 = _context["catch"](3);
          _didIteratorError = true;
          _iteratorError = _context.t1;

        case 17:
          _context.prev = 17;
          _context.prev = 18;

          if (!_iteratorNormalCompletion && _iterator.return != null) {
            _iterator.return();
          }

        case 20:
          _context.prev = 20;

          if (!_didIteratorError) {
            _context.next = 23;
            break;
          }

          throw _iteratorError;

        case 23:
          return _context.finish(20);

        case 24:
          return _context.finish(17);

        case 25:
        case "end":
          return _context.stop();
      }
    }
  }, _marked, null, [[3, 13, 17, 25], [18,, 20, 24]]);
}

export default function merge(arrays) {
  return Array.from(flatten(arrays));
}